<template>
    <collapsible-card :title="'Vessel Information'" v-show="showInfo" ref="cCard">
        <div class="cardContent">
            <div v-if="general.length > 0" class="category">
                <h3 class="categoryTitle">General</h3>
                <div> 
                    <div v-for="obj in general" :key="obj.field" class="dataItem">
                        <p v-if="obj.field === 'Owner'">{{obj.field}}: <router-link :to="{name: 'Providers', params: {provider: obj.val}}" class="link dataEmphasis">{{obj.val}}</router-link></p>
                        <p v-else-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
            </div>
            <div v-if="dimension.length > 0" class="category">
                <h3 class="categoryTitle">Dimensions</h3>
                <div> 
                    <div v-for="obj in dimension" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
            </div>
            <div v-if="capacity.length > 0" class="category">
                <h3 class="categoryTitle">Capacity</h3>
                <div> 
                    <div v-for="obj in capacity" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
            </div>
            <div v-if="propulsion.length > 0" class="category">
                <h3 class="categoryTitle">Propulsion</h3>
                <div> 
                    <div v-for="obj in propulsion" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
            </div>
            <div v-if="design.length > 0" class="category">
                <h3 class="categoryTitle">Design</h3>
                <div> 
                    <div v-for="obj in design" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
            </div>
            <div v-if="other.length > 0" class="category">
                <h3 class="categoryTitle">Other</h3>
                <div> 
                    <div v-for="obj in other" :key="obj.field" class="dataItem">
                        <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                        <a v-else-if="obj.link" class="dataEmphasis link" :href="obj.link" target="_blank">{{obj.field}}</a>
                        <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                    </div>
                </div>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import {readFromObj, formatDateLT} from '../../helpers/Formatting.js';
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: "vessel-info",
    components: {
        CollapsibleCard
    },
    data: () => ({
        showInfo: false,
        general: [],
        dimension: [],
        capacity: [],
        propulsion: [],
        design: [],
        other: []
    }),
    methods: {
       updateInfo: function(vesselInfoObj) {
           var globv = this;

            if (!(vesselInfoObj && vesselInfoObj instanceof Object && Object.keys(vesselInfoObj).length > 0)) {
                return;
            }

             // update general info
            if (vesselInfoObj['general']) {
                let expectedVariables = [
                    {
                        varName: "name",
                        fieldName: "Name"
                    },
                    {
                        varName: "nameDate",
                        fieldName: "Name Date",
                        format: formatDateLT
                    },
                    {
                        varName: "mmsi",
                        fieldName: "MMSI"
                    },
                    {
                        varName: "imo",
                        fieldName: "IMO"
                    },
                    {
                        varName: "status",
                        fieldName: "Status",
                        capitalize: true,
                    },
                    {
                        varName: "callSign",
                        fieldName: "Call Sign"
                    },
                    {
                        varName: "class",
                        fieldName: "Vessel Class"
                    },
                    {
                        varName: "vesselType.generic",
                        fieldName: "Generic Vessel Type"
                    },
                    {
                        varName: "vesselType.detailed",
                        fieldName: "Detailed Vessel Type"
                    },
                    {
                        varName: "flag",
                        fieldName: "Flag"
                    },
                    {
                        varName: "owner",
                        fieldName: "Owner"
                    },
                    {
                        varName: "classificationSociety",
                        fieldName: "Classification Society"
                    },
                    {
                        varName: "yearBuilt",
                        fieldName: "Year"
                    },
                    {
                        varName: "hullNumber",
                        fieldName: "Hull Number"
                    },
                    {
                        varName: "builder",
                        fieldName: "Builder"
                    },
                    {
                        varName: "grossTonnage",
                        fieldName: "Gross Tonnage",
                    },
                    {
                        varName: "dwt",
                        fieldName: "Dead Weight",
                        unit: " t"
                    },
                    {
                        varName: "topSpeed",
                        fieldName: "Top Speed",
                        unit: " kn"
                    },
                    {
                        varName: "capabilities",
                        fieldName: "Capabilities"
                    }
                ]
                
                globv.general = readFromObj(vesselInfoObj['general'], expectedVariables);
            }

            // update dimension info
            if (vesselInfoObj['dimensions']) {
                globv.dimension = [];
                let lengthOverall = false;
                let breadthExtreme = false;
                if (vesselInfoObj['dimensions']['lengthOverall']) {
                    lengthOverall = vesselInfoObj['dimensions']['lengthOverall'];
                }
                if (vesselInfoObj['dimensions']['breadthExtreme']) {
                    breadthExtreme = vesselInfoObj['dimensions']['breadthExtreme'];
                }

                if (lengthOverall && breadthExtreme) {
                    globv.dimension.push({
                        field: "Length Overall x Breadth Extreme",
                        val: lengthOverall + " x " + breadthExtreme + " m"
                    });
                }
                else if (lengthOverall) {
                    globv.dimension.push({
                        field: "Length Overall",
                        val: lengthOverall + " m"
                    });
                }
                else if (breadthExtreme) {
                    globv.dimension.push({
                        field: "Breadth Extreme",
                        val: breadthExtreme + " m"
                    });
                }
                
                let expectedVariables = [
                    {
                        varName: "deckSize",
                        fieldName: "Deck Size",
                        unit: " m²"
                    },
                    {
                        varName: "keelToMast",
                        fieldName: "Keel to Mast",
                        unit: " m"
                    },
                    {
                        varName: "maxAirDraught",
                        fieldName: "Max Air Draught"
                    },
                    {
                        varName: "maxDraught",
                        fieldName: "Max Draught"
                    },
                ]

                globv.dimension = globv.dimension.concat(readFromObj(vesselInfoObj['dimensions'], expectedVariables));
            }

            // update capacity info
            if (vesselInfoObj['capacity']) {
                let expectedVariables = [
                    {
                        varName: "displacement",
                        fieldName: "Displacement"
                    },
                    {
                        varName: "netTonnage",
                        fieldName: "Net Tonnage"
                    },
                    {
                        varName: "grainCubic",
                        fieldName: "Grain Cubic Capacity"
                    },
                    {
                        varName: "liquidCubic98",
                        fieldName: "Liquid Cubic Capacity (filled to 98%)"
                    },
                    {
                        varName: "teu",
                        fieldName: "TEU"
                    },
                    {
                        varName: "tpcmi",
                        fieldName: "Tons per Cm"
                    },
                ]

                globv.capacity = readFromObj(vesselInfoObj['capacity'], expectedVariables);
            }

            // update propulsion info
            if (vesselInfoObj['propulsion']) {
                let mcoUnit = "";
                if (vesselInfoObj['propulsion']['engine'] && vesselInfoObj['propulsion']['engine']['mcoUnit']) {
                    mcoUnit = " " + vesselInfoObj['propulsion']['engine']['mcoUnit'];
                }
                let expectedVariables = [
                    {
                        varName: "propulsionType",
                        fieldName: "Propulsion Type"
                    },
                    {
                        varName: "engine.engineModel",
                        fieldName: "Engine Model"
                    },
                    {
                        varName: "engine.engineDesigner",
                        fieldName: "Engine Designer"
                    },
                    {
                        varName: "engine.numEngines",
                        fieldName: "Number of Engines"
                    },
                    {
                        varName: "engine.mco",
                        fieldName: "Maximum Continuous Output",
                        unit: mcoUnit
                    },
                    {
                        varName: "engine.mcoRpm",
                        fieldName: "Maximum Continuous Output RPM"
                    },
                    {
                        varName: "propeller.propellerType",
                        fieldName: "Propeller Type"
                    },
                    {
                        varName: "propeller.numPropellers",
                        fieldName: "Number of Propellers"
                    },
                ]

                globv.propulsion = readFromObj(vesselInfoObj['propulsion'], expectedVariables);
            }

            // update design info
            if (vesselInfoObj['design']) {
                let expectedVariables = [
                    {
                        varName: "iceClass",
                        fieldName: "Ice Class"
                    }
                ]

                globv.design = readFromObj(vesselInfoObj['design'], expectedVariables);

                if (vesselInfoObj['design']['hasTankCoated']) {
                    globv.design.push({
                        field: "Tank is Coated"
                    });
                }
            }

            if (vesselInfoObj['specLink']) {
                globv.other = [];
                globv.other.push({
                    field: "Link to Specs",
                    link: vesselInfoObj['specLink']
                })
            }

            globv.showInfo = globv.general.length + globv.dimension.length + globv.capacity.length + globv.propulsion.length + globv.design.length > 0;
            globv.$refs.cCard.adjustHeight();
       },
       reset: function() {
           var globv = this;
           globv.showInfo = false;
           globv.general = [];
           globv.dimension = [];
           globv.capacity = [];
           globv.propulsion = [];
           globv.design = [];
           globv.other = [];
       }
    }
}
</script>